import { render, staticRenderFns } from "./Element1H1.vue?vue&type=template&id=8ff143d4"
import script from "./Element1H1.vue?vue&type=script&lang=ts"
export * from "./Element1H1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HtmlBrandButton: require('/codebuild/output/src3458403893/src/acredo-website/components/html/htmlBrandButton.vue').default})
